/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect, useRef } from 'react';
import useStyles from '../useStyles';
import { DialogContext } from '../../../contexts/DialogContext';
import { dialogActions } from '../../../reducers/dialogReducer';
import SettingConfigMaterialTypeTable from './SettingConfigMaterialTypeTable';
import styleConst from '../../../constants/style';
import useAxios from '../../../hooks/useAxios';
import useCancelToken from '../../../hooks/useCancelToken';
import Typography from '../../../components/Typography/Typography';
import PaperContainer from '../../../components/PaperContainer/PaperContainer';
import TablePagination from '../../../components/TablePagination/TablePagination';
import Snackbar from '../../../components/Snackbar/Snackbar';
import { getMaterialList } from '../../../services/settings-config';

const SettingConfigMaterialType = () => {
  const { classes } = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [materialList, setMaterialList] = useState([]);
  const snackbarTimer = useRef(null);
  const { dialogDispatch } = useContext(DialogContext);
  const { newCancelToken } = useCancelToken();

  const rowsPerPage = styleConst.ROWS_PER_PAGE;

  const getMaterialListConfig = async (page = currentPage, keyWord, isFromLastPage = false) => {
    const data = keyWord ? { page, keyWord } : { page };
    const cancelToken = newCancelToken();
    await getMaterialList({
      data,
      cancelToken,
      onSuccess: (result) => {
        const { count, materialConfigList: materialListData } = result;
        setTotalRows(count || materialListData.length);
        setMaterialList(
          materialListData.map((item) => ({
            materialId: item.materialId,
            materialName: item.materialName,
          }))
        );
        setIsLoading(false);
      },
      onError: (result, _rtCode, noPrivilegeMsg) => {
        if (isFromLastPage || currentPage <= 1) {
          dialogDispatch({
            type: dialogActions.OPEN,
            config: {
              title: '無法取得材質列表',
              message:
                noPrivilegeMsg ||
                `目前無法取得材質列表，請確認網路是否正常或聯繫軟體部門：${result}`,
            },
          });
          return;
        }
        setCurrentPage(currentPage - 1);
        getMaterialListConfig(currentPage - 1, '', true);
      },
    });
  };

  const handleChangePage = (newPage) => {
    setCurrentPage(newPage);
    getMaterialListConfig(newPage);
  };

  useEffect(() => {
    setCurrentPage(1);
    getMaterialListConfig();

    return () => {
      clearTimeout(snackbarTimer.current);
    };
  }, []);

  return (
    <PaperContainer className={classes.container}>
      <Typography variant="h6">材質種類設定</Typography>
      <SettingConfigMaterialTypeTable isLoading={isLoading} tableContentList={materialList} />
      {/* TODO: 20251214 Shane - 暫時先不使用分頁功能 */}
      {/* <TablePagination
        isEditing={false}
        totalRows={totalRows}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onChangePage={handleChangePage}
      /> */}
    </PaperContainer>
  );
};

export default SettingConfigMaterialType;
